<!-- 翻译 -->
<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { languages } from '@/i18n'

const { locale } = useI18n()

const currentLocale = computed(() => locale.value)

const handleSelect = (value) => {
    if (value !== currentLocale.value) {
        locale.value = value
        localStorage.setItem('arco-locale', value)
        // 重载页面以应用语言切换
        window.location.reload()
    }
}

</script>

<template>
    <a-dropdown @select="handleSelect" position="br">
        <a-button type="text" class="locale-switch">
            <template #icon>
                <!-- 自定义 SVG 地球图标 -->
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                </svg>
            </template>
            <span class="pc">{{ $t('common.language') }}</span>
            <icon-down class="pc" />
        </a-button>
        <template #content>
            <a-doption v-for="lang in languages" :key="lang.value" :value="lang.value"
                :selected="lang.value === currentLocale">
                {{ lang.label }}
            </a-doption>
        </template>
    </a-dropdown>
</template>

<style scoped lang="less">
</style>